<template>
    <kiosk-group-details :teamId="props.teamId" :groupId="props.groupId">
        <group-user-list
            :teamId="props.teamId"
            :groupId="props.groupId"
            :groupName="group.name"
            :canManageUsers="true"
        ></group-user-list>
    </kiosk-group-details>
</template>

<script setup>
import KioskGroupDetails from '../details/KioskGroupDetails.vue';
import GroupUserList from '~/components/settings/teams/groups/form/users/GroupUserList.vue';
import { useGroupDetails } from '../composables/useGroupDetails';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    groupId: {
        type: String,
        required: true,
    },
});

const { group } = useGroupDetails();
</script>
